module.exports = __webpack_public_path__ + "img/new_search.ed5d4422.svg";